export default "__VITE_ASSET__DwDC5eeN__"